// extracted by mini-css-extract-plugin
export default {"wrap":"StudAddPage_wrap__HGL8t","content":"StudAddPage_content__4GFtb","btns":"StudAddPage_btns__frteR","upload":"StudAddPage_upload__EFSZK"};